import {
  EMAIL_MODULE_REQUEST,
  EMAIL_MODULE_FAILURE,
  EMAIL_MODULE_SUCCESS,
  EMAIL_MODULE_UPDATE_SUCCESS,
  EDIT_MODULE_TOGGLE_HTML,
  EDIT_MODULE_TOGGLE_CSS,
  EDIT_MODULE_TOGGLE_DATA,
  EDIT_MODULE_TOGGLE_TEMPLATE,
  EDIT_MODULE_TOGGLE_PREVIEW,
  EDIT_MODULE_TOGGLE_IMAGEPICKER,
  EMAIL_MODULE_SET_KEY_VALUE,
  EMAIL_MODULE_UPDATE_NAME_VALUE,
} from "../constants/ActionTypes";

const initialState = {
  display: "desktop",
  unsavedChanges: false,

  showHtml: true,
  showCss: false,
  showData: true,
  showTemplate: false,
  showPreview: true,
  showImagePicker: false,

  emailModule: {
    fields: {},
    id: null,
    key: null,
    name: "general/spacer",
    template: "ABC",
    archived: false,
    createdAt: "2016-07-23T11:06:07.000Z",
    updatedAt: "2016-07-23T11:06:07.000Z",
  },
};

export default function emailModuleEditor(state = initialState, action) {
  switch (action.type) {
    case EMAIL_MODULE_REQUEST:
      return Object.assign({}, state, {
        unsavedChanges: false,
        emailModule: {},
      });

    case EMAIL_MODULE_FAILURE:
      return Object.assign({}, state, {
        emailModule: {
          failed: true,
        },
      });

    case EMAIL_MODULE_SUCCESS:
      return Object.assign({}, state, {
        unsavedChanges: false,
        emailModule: action.data,
      });

    case EMAIL_MODULE_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        unsavedChanges: false,
      });

    case EDIT_MODULE_TOGGLE_HTML:
      return Object.assign({}, state, {
        showHtml: !state.showHtml,
      });

    case EDIT_MODULE_TOGGLE_CSS:
      return Object.assign({}, state, {
        showCss: !state.showCss,
      });

    case EDIT_MODULE_TOGGLE_DATA:
      return Object.assign({}, state, {
        showData: !state.showData,
      });

    case EDIT_MODULE_TOGGLE_TEMPLATE:
      return Object.assign({}, state, {
        showTemplate: !state.showTemplate,
      });

    case EDIT_MODULE_TOGGLE_PREVIEW:
      return Object.assign({}, state, {
        showPreview: !state.showPreview,
      });

    case EDIT_MODULE_TOGGLE_IMAGEPICKER:
      return Object.assign({}, state, {
        showImagePicker: !state.showImagePicker,
      });

    case EMAIL_MODULE_SET_KEY_VALUE:
      return Object.assign({}, state, {
        unsavedChanges: true,
        emailModule: Object.assign({}, state.emailModule, {
          [action.key]: action.value,
        }),
      });

    case EMAIL_MODULE_UPDATE_NAME_VALUE:
      return Object.assign({}, state, {
        unsavedChanges: true,
        emailModule: Object.assign({}, state.emailModule, {
          name: action.value,
        }),
      });
  }

  return state;
}
